<template>
  <div
    class="product_qty"
    :class="{
      disabled: disabled,
      showtime_input: theme == 'showtime',
      controlRight: mode == 'controlRight',
      notBoder: mode == 'notBoder',
    }"
  >
    <button type="button" @click="!disabled && handleReduce()" class="subtract">
      <span v-if="mode !== 'controlRight'">-</span>
      <span v-else class="iconfont icon-cm-youjiantou2"></span>
    </button>
    <input
      type="text"
      name="inputnum"
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabled"
      class="product_qty_num"
      ref="input"
      @paste.capture.prevent="handleFalse"
      :value="currentValue"
      @change="handleChange"
    />
    <button type="button" @click="!disabled && handleAdd()" class="add">
      <span v-if="mode !== 'controlRight'">+</span>
      <span v-else class="iconfont icon-cm-youjiantou2"></span>
    </button>
  </div>
</template>
<script>
import API from "@/js/API.js";
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: 1,
    },
    min: {
      type: [Number],
      default: 1,
    },
    max: {
      type: [Number],
      default: 100000,
    },
    disabled: {
      type: [Boolean],
      default: false,
    },
    step: {
      type: [Number],
      default: 1,
    },
    type: {
      type: [String],
      default: null,
    },
    productId: {
      type: [Number],
      default: null,
    },
    theme: {
      type: [String],
    },
    mode: {
      type: String,
    },
  },
  emits: ["change"],
  data() {
    // Vue组件是单向数据流，无法直接修改prop中的值
    let currentValue = 0;
    if (this.value > this.max) {
      currentValue = this.max;
    } else if (this.value < this.min) {
      currentValue = this.min;
    } else {
      currentValue = this.value;
    }
    return {
      currentValue: currentValue,
    };
  },
  methods: {
    handleFalse(){
     return false;
    },
    isValueNumber(value) {
      return /(^-?[0-9]+\.{1}\d+$)|(^-?[1-9][0-9]*$)|(^-?0{1}$)/.test(value);
    },
    handleChange(event) {
      let { value } = event.target;
      if (isNaN(value) || value > 100) {
        this.$axios.post(API.statis_event, {
          name: "checkout.invalid_number",
          parameters: {
            pathname: window.location.pathname,
            value,
          },
        })
        if(isNaN(value) || value > 100000){
          event.target.value = this.currentValue;
          return
        }
      }
      let max = this.max;
      let min = this.min;
      let val = this.filterinputnum(event.target.value, min, this.currentValue);
      this.currentValue = val;
      event.target.value = val;
      if (val > max) this.currentValue = max;
      if (val < min) this.currentValue = min;
      this.$emit("change", this.currentValue);
    },
    handleAdd() {
      if (this.currentValue >= this.max) return;
      this.currentValue += this.step;
      this.$emit("change", this.currentValue);
    },
    handleReduce() {
      if (this.currentValue <= this.min) return;
      this.currentValue -= this.step;
      this.$emit("change", this.currentValue);
    },
    updateVal(val) {
      if (val > this.max) val = this.max;
      if (val < this.min) val = this.min;
      this.currentValue = Math.round(val);
    },
  },
  // beforeUpdate() {
  //   console.log("beforeUpdate", this.currentValue);
  // },
  // updated() {
  //   console.log("updated", this.currentValue);
  // },
  // beforeMount() {
  //   if (this.type == "productDetail") {
  //     window.sessionStorage.setItem("inputnum", JSON.stringify({}));
  //   }
  // },
  // mounted() {
  //   // this.$refs.input.value = 7;
  //   // this.$refs.input.value = 7;
  //   // console.log("mounted", this.$refs.input);
  // },
  watch: {
    currentValue(val) {
      if (this.type == "productDetail") {
        let inputnum = {};
        inputnum[this.productId] = val;
        window.sessionStorage.setItem("inputnum", JSON.stringify(inputnum));
      }
    },
    value(val) {
      this.updateVal(val);
    },
  },
};
</script>
<style scoped lang="scss">
.disabled {
  opacity: 0.5 !important;
  button {
    cursor: default !important;
  }
}
.product_qty {
  display: inline-block;
  button {
    background: rgba(255, 255, 255, 0.8);
    padding: 0;
    height: 36px;
    width: 36px;
    line-height: 34px;
    border: 1px solid rgba(17, 17, 17, 0.2);
    float: left;
  }
  input {
    font-size: 13px;
    color: #555;
    background: #f5f5f5;
    height: 36px;
    width: 36px;
    line-height: 34px;
    text-align: center;
    border: 1px solid rgba(17, 17, 17, 0.2);
    margin: 0px;
    cursor: pointer;
    float: left;
    border-radius: unset;
    -webkit-appearance: none !important;
    &::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0;
      -moz-appearance: textfield;
    }
  }
}
.showtime_input {
  input,
  button {
    border-color: #dedede;
    height: 36px;
  }
  button {
    width: 20px;
    background: transparent;
    color: #858585;
  }
  input {
    width: 60px;
  }
}
.controlRight {
  position: relative;
  width: 64px;
  .product_qty_num {
    display: block;
    font-size: 16px;
    line-height: 38px;
    text-align: center;
    width: 42px;
    height: 33px;
    padding: 0;
    border: 1px solid #dcdfe6;
    border-radius: 3px;
    background: white;
  }
  button {
    background: #222f3e;
    width: 20px;
    height: 16px;
    line-height: 16px;
    position: absolute;
    right: 4px;
    color: white;
    text-align: center;
    span {
      display: inline-block;
      font-size: 12px;
    }
  }
  .add {
    top: 0;
    span {
      transform: rotate(-90deg) scale(0.7) translateX(2px);
    }
  }
  .subtract {
    bottom: 0;
    span {
      transform: rotate(90deg) scale(0.7) translateX(-2px);
    }
  }
}
.notBoder {
  width: 80px;
  height: 30px;
  .subtract,
  .add {
    width: 25%;
    height: 100%;
    line-height: 28px;
  }
  .add {
    border-left: none;
  }
  .subtract {
    border-right: none;
  }
  .product_qty_num {
    width: 50%;
    height: 100%;
    line-height: 1;
    border-left: none;
    background: #fff;
    border-right: none;
  }
  @media screen and(max-width: 768px) {
    width: 80px;
    height: 21px;
    .subtract,
    .add {
      line-height: 21px;
    }
  }
}
</style>
